"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidArgumentError = void 0;
exports.validateNotBlank = validateNotBlank;
class InvalidArgumentError extends Error {
}
exports.InvalidArgumentError = InvalidArgumentError;
function validateNotBlank(value, errorMessage) {
    if (value == null || value.length === 0) {
        throw new InvalidArgumentError(errorMessage);
    }
}
//# sourceMappingURL=validation.js.map